import {NoteGroupIcon} from "crqlar-react-common/dist/components/note/NoteGroupIcon";
import {useNoteGroupIndex} from "crqlar-react-common/dist/utils/hooks/notes/useNoteGroupIndex";
import {
    Alert,
    Box,
    Button,
    ButtonGroup,
    Checkbox,
    Divider,
    FormControlLabel,
    Grid,
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Stack,
    TextField,
    Tooltip,
    Typography,
    useMediaQuery,
    useTheme
} from "@mui/material";
import React, {useEffect, useRef, useState} from "react";
import {
    Reservation,
    ReservationStatus,
    SlotType
} from "crqlar-react-common/dist/models/reservation/reservation.model";
import {Resource} from "crqlar-react-common/dist/models/resource/resource.model";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
import AddIcon from "@mui/icons-material/Add";
import {useAllChildResources} from "crqlar-react-common/dist/utils/hooks/resources/useAllRootResources";
import {
    AgeCategory,
    AgeCategoryType
} from "crqlar-react-common/dist/models/ageCategory/ageCategory.model";
import CountTextField from "crqlar-react-common/dist/components/CountTextField";
import CloseIcon from "@mui/icons-material/Close";
import EuroIcon from '@mui/icons-material/Euro';
import {Service} from "crqlar-react-common/dist/models/service/service.model";
import {useCheckLinkedResources} from "crqlar-react-common/dist/utils/reservation.util";
import EmailIcon from "@mui/icons-material/Email";
import LinkIcon from "@mui/icons-material/Link";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PollIcon from "@mui/icons-material/Poll";
import SurveyInviteDialog from "../../surveys/share/SurveyInviteDialog";
import {useCurrentApp} from "crqlar-react-common/dist/utils/hooks/app/useOrganizationApps";
import {useSector} from "crqlar-react-common/dist/utils/hooks/sector/useSectors";
import CDatePicker from "crqlar-react-common/dist/components/CDatePicker";
import {SectorType} from "crqlar-react-common/dist/models/sector/sector.model";
import SimpleChargeDialog from "../../system/billing/folio/SimpleChargeDialog";
import FolioDialog, {FolioDialogView} from "../../system/billing/folio/editor/FolioDialog";
import PaymentIcon from "@mui/icons-material/Payment";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import {findLatestNonVoidFolio, findPrimaryFolioItem} from "../../system/billing/folio/folioCharge.util";
import {DigitalSigningService} from "../../digitalSigning/digitalSigning.service";
import DigitalSigningDetailsDialog from "../../digitalSigning/details/DigitalSigningDetailsDialog";
import {isSignedDigitalSigning} from "../../digitalSigning/share/digitalSigningFlow.util";
import DigitalSigningSignatureButton from "../../digitalSigning/share/DigitalSigningSignatureButton";
import {useLatestReservationDigitalSigning} from "../../digitalSigning/share/useLatestDigitalSigning";
import {useQuery, useQueryClient} from "react-query";
import {ReservationGroupService} from "crqlar-react-common/dist/services/reservation/reservationGroup.service";
import {ServiceService} from "crqlar-react-common/dist/services/service/service.service";
import {preparePackageFolio as buildPackageFolio} from "../packages/packageReservation.util";
import {FolioService} from "crqlar-react-common/dist/services/billing/folio.service";
import {FolioStatus} from "crqlar-react-common/dist/models/billing/folio.model";
import {FolioItemService} from "crqlar-react-common/dist/services/billing/folioItem.service";
import {useOrganization} from "crqlar-react-common/dist/state/auth.reducer";
import {LoadingButton} from "@mui/lab";
import {RateCalculationService} from "crqlar-react-common/dist/services/rate/rateCalculation.service";
import {FolioItem} from "crqlar-react-common/dist/models/billing/folioItem.model";
import {hasRequiredResources} from "crqlar-react-common/dist/utils/hooks/reservations/reservations.utils";
import {useService} from "crqlar-react-common/dist/utils/hooks/services/useServices";
import {useResources} from "crqlar-react-common/dist/utils/hooks/resources/useResources";
import {useAllSectors} from "crqlar-react-common/dist/utils/hooks/sectors/useSectors";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import {addHours, addMinutes} from "crqlar-react-common/dist/utils/date.util";
import ReservationStatusSelect from "../ReservationStatusSelect";
import {findRateByDate} from "crqlar-react-common/dist/utils/rate.util";
import {History} from "@mui/icons-material";
import {useCanViewLogs} from "crqlar-react-common/dist/utils/hooks/logs/useCanViewLogs";
import ReservationUpdateOptionDialog from "./ReservationUpdateOptionDialog";
import ReservationCopyButton from "./ReservationCopyButton";
import PrintIcon from "@mui/icons-material/Print";
import {useReadOnly} from "crqlar-react-common/dist/utils/hooks/users/useReadOnly";
import {
    DEFAULT_AGE_CATEGORY_TYPES,
    resolveDefaultAgeCategories
} from "../../common/ageCategoryDefaults";

const RESTAURANT_INPUT_MIN_HEIGHT = 48

interface Props {
    reservation?: Reservation
    setReservation: (reservation?: Reservation) => void
    resources?: Resource[],
    // availabilityForActiveReservation?: RestaurantAvailableTablesResponse
    // loadingAvailabilities: boolean,
    onSave?: (
        allowNotify?: boolean,
        updateOption?: 'single' | 'linkedReservations' | 'subsequentLinkedReservations',
        changes?: {
            field: string
            oldValue: any
            newValue: any
        }[],
        eatPeriod?: 'breakfast' | 'lunch' | 'dinner' | 'all' | undefined
    ) => void,
    onSaveBlock?: (name: string | undefined) => void,
    onResend?: () => void,
    ageCategories?: AgeCategory[]
    children?: React.ReactNode
    restaurantEvent?: React.ReactNode
    restaurantInputSizing?: boolean
    slotTypeToggle?: React.ReactNode
    // Added new fields for service and resources to match the product requirements
    position1Content?: React.ReactNode
    position2Content?: React.ReactNode
    restaurantResource?: React.ReactNode
    tableResources?: React.ReactNode
    // Warning shown directly above the resource picker (e.g. reservation outside open availability)
    availabilityWarning?: React.ReactNode
    onClose: () => void
    onShowFolios?: () => void
    onShowLogs?: () => void
    serviceInfo?: Service
    onOpenCommunication?: () => void
    onOpenFormSelector?: () => void
    originalReservation?: Reservation
    linkedReservations?: Reservation[]
    selectedSlotType?: SlotType
    defaultAllowNotify?: boolean
    loading?: boolean
    onSaveAndSendNoShowLink?: () => void
}

const ReservationDetailsWrapper = ({
                                       reservation,
                                       setReservation,
                                       resources,
                                       // availabilityForActiveReservation,
                                       // loadingAvailabilities,
                                       onSave,
                                       onSaveBlock,
                                       onResend,
                                       ageCategories,
                                       children,
                                       restaurantEvent,
                                       restaurantInputSizing = false,
                                       position1Content,
                                       position2Content,
                                       restaurantResource,
                                       tableResources,
                                       availabilityWarning,
                                       slotTypeToggle,
                                       onClose,
                                       onShowFolios,
                                       onShowLogs,
                                       serviceInfo,
                                       onOpenCommunication,
                                       onOpenFormSelector,
                                       originalReservation,
                                       linkedReservations,
                                       selectedSlotType = SlotType.RESERVATION,
                                       defaultAllowNotify = true,
                                       loading,
                                       onSaveAndSendNoShowLink
                                   }: Props) => {

    const {t, tFallback} = useLocalize()
    const noteGroupIndex = useNoteGroupIndex()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const [actionsMenuAnchor, setActionsMenuAnchor] = useState<null | HTMLElement>(null)
    const [createMenuAnchor, setCreateMenuAnchor] = useState<null | HTMLElement>(null)
    const [saveMenuAnchor, setSaveMenuAnchor] = useState<null | HTMLElement>(null)
    // Read-only users can open and view a reservation, but not edit any field or fire any action.
    const readOnly = useReadOnly()
    const canEdit = !readOnly
    const [allowNotify, setAllowNotify] = useState(defaultAllowNotify)
    const [showChargeDialog, setShowChargeDialog] = useState(false)
    // The new folio dialog (Charge, "Folios"); mounted only while open, so it starts fresh
    const [folioDialog, setFolioDialog] = useState<{view: FolioDialogView, folioId?: string, preparing?: boolean}>()
    // What the guest signed, opened from the footer once they signed
    const [showDigitalSigning, setShowDigitalSigning] = useState(false)
    const [showSurveyDialog, setShowSurveyDialog] = useState(false)
    const organization = useOrganization()
    const queryClient = useQueryClient()
    const {canViewLogs} = useCanViewLogs()
    const service = useService(reservation?.serviceId)

    // Distinguish spa packages from restaurant serial reservations: both are group reservations,
    // but spa package groups carry a PACKAGE service (set at creation in AddNewPackageReservationsDialog),
    // whereas restaurant serial groups are created empty. A package's members share its one folio, charged as
    // a whole (one priced row per package service, plus extras), not the single member that happens to be open.
    const reservationGroupQuery = useQuery(
        ['reservationGroup', reservation?.reservationGroupId],
        () => ReservationGroupService.getReservationGroupById(reservation!.reservationGroupId!),
        {enabled: !!reservation?.reservationGroupId}
    )
    const reservationGroup = reservationGroupQuery.data
    // Read here rather than through useService, which can't tell a service still read from none
    const groupServiceQuery = useQuery(
        ['reservationGroupService', reservationGroup?.serviceId],
        () => ServiceService.getServiceById(reservationGroup!.serviceId!),
        {enabled: !!reservationGroup?.serviceId, refetchOnWindowFocus: false}
    )
    const packageService = groupServiceQuery.data?.isPackage ? groupServiceQuery.data : undefined
    const isSpaPackageGroup = !!packageService
    // The package the reservation is a member of: its one folio and its signing are every
    // member's. A package of one is a single reservation, like the members of any other group
    const packageMemberCount = new Set((reservationGroup?.reservationIds ?? []).filter(Boolean)).size
    const packageGroup = isSpaPackageGroup && packageMemberCount > 1 ? reservationGroup : undefined
    // Until both are read a member's Charge waits: a package's opens the package's folio
    const groupPending = !!reservation?.reservationGroupId
        && (!reservationGroupQuery.isFetched || (!!reservationGroup?.serviceId && !groupServiceQuery.isFetched))

    // Group members never get a transactional email: a series is created silently (handleSave in
    // ReservationDialog) and the API skips every reservation carrying a reservationGroupId, on
    // create and update alike. So "& send e-mail" is not offered for them - it would do nothing.
    // A series trimmed to one sitting is created as a plain reservation and still emails.
    const isSerialCreate = !reservation?.id
        && selectedSlotType === SlotType.SERIAL
        && (linkedReservations?.length ?? 0) > 1
    const isGroupMember = !!reservation?.id && !!reservation?.reservationGroupId
    const isSerialMember = isGroupMember && reservationGroupQuery.isFetched && !isSpaPackageGroup

    const reservationResources = useResources(reservation?.resourceIds || [])
    const [printTarget, setPrintTarget] = useState<'printout' | 'legacy' | null>(null)
    const [latestFolioItemId, setLatestFolioItemId] = useState<string | undefined>(undefined)

    const [reservationUpdateOptionDialogOpen, setReservationUpdateOptionDialogOpen] = useState(false)
    const createButtonGroupRef = useRef<HTMLDivElement>(null)
    const saveButtonGroupRef = useRef<HTMLDivElement>(null)

    // When a block is being created from a calendar cell drag, the resource is already
    // chosen by where the user dragged — hide the resource picker. The sidebar "+" path
    // does not prefill resourceIds, so the picker still shows there.
    const blockHasPreselectedResource =
        selectedSlotType === SlotType.BLOCK &&
        !originalReservation?.id &&
        !!originalReservation?.resourceIds?.length

    // For sidebar-initiated block creation, both block name and resources must be filled.
    const requireBlockFields =
        selectedSlotType === SlotType.BLOCK &&
        !originalReservation?.id &&
        !blockHasPreselectedResource

    // Block name assignment
    const [blockName, setBlockName] = useState<string | undefined>()
    const [blockValidationAttempted, setBlockValidationAttempted] = useState(false)

    const blockNameMissing = requireBlockFields && !blockName?.trim()
    const blockResourcesMissing = requireBlockFields && !reservation?.resourceIds?.length

    const appData = useCurrentApp()
    const sector = useSector(reservation?.sectorId ?? appData?.configuration?.sectorId)
    const confirmedTemplate = sector?.notificationSettings?.confirmationSettings?.reservationConfirmed
    const updatedTemplate = sector?.notificationSettings?.confirmationSettings?.reservationUpdated
    const cancelTemplate = sector?.notificationSettings?.confirmationSettings?.reservationCancelled
    const [folioId, setFolioId] = useState<string>()
    let canSendNotification = false
    if (!reservation?.id && reservation?.status == ReservationStatus.CONFIRMED && confirmedTemplate) {
        canSendNotification = true
    } else if (reservation?.id && reservation.status == ReservationStatus.CONFIRMED && originalReservation?.expectedStartDate?.getTime() != reservation?.expectedStartDate?.getTime() && updatedTemplate) {
        canSendNotification = true
    } else if (reservation?.status == ReservationStatus.CANCELLED && originalReservation?.status !== reservation?.status && cancelTemplate) {
        canSendNotification = true
    }

    const restaurantId = reservation?.resourceIds?.find(r => resources?.find(res => res?.id === r))
    const tables = useAllChildResources(restaurantId ? [restaurantId] : [])

    const restaurantSectorId = useAllSectors().find(s => s.sectorType === SectorType.RESTAURANT)?.id

    // The latest signing, read once per opening (and after the new folio dialog) whatever the
    // settings offer now - a sector taken off them keeps its signed link: a signed one turns Charge into
    // "Confirm charge", the folio dialog shows the signing itself. A package's member finds the
    // package's as well
    const latestDigitalSigningQuery = useLatestReservationDigitalSigning(reservation?.id, packageGroup?.id)
    const latestDigitalSigning = latestDigitalSigningQuery.data
    const digitalSigningSigned = latestDigitalSigning?.status === 'SIGNED'

    const resourceWarnings = useCheckLinkedResources(reservation)

    const handleUpdateRes = (
        updateOption: 'single' | 'linkedReservations' | 'subsequentLinkedReservations',
        changes?: {
            field: string
            oldValue: any
            newValue: any
        }[],
        eatPeriod?: 'breakfast' | 'lunch' | 'dinner' | 'all' | undefined
    ) => {
        setReservationUpdateOptionDialogOpen(false)
        if (updateOption === 'single') {
            selectedSlotType !== SlotType.BLOCK
                ? onSave?.(allowNotify)
                : onSaveBlock?.(blockName)
        } else if (updateOption === 'linkedReservations' && linkedReservations) {
            selectedSlotType !== SlotType.BLOCK
                ? onSave?.(allowNotify, 'linkedReservations', changes, eatPeriod)
                : onSaveBlock?.(blockName)
        } else if(updateOption === 'subsequentLinkedReservations' && linkedReservations) {
            selectedSlotType !== SlotType.BLOCK
                ? onSave?.(allowNotify, 'subsequentLinkedReservations', changes, eatPeriod)
                : onSaveBlock?.(blockName)
        }
    }

    useEffect(() => {
        if(printTarget && reservation?.id) {
            const path = printTarget === 'printout'
                ? `/print/printout/reservationConfirmation/${reservation.id}`
                : `/print/reservationConfirmation/${reservation.id}`
            window.open(path, '_blank')
            setPrintTarget(null)
        }
    }, [printTarget, reservation?.id])

    const prepareLatestFolio = useQuery(['latestFolio', reservation?.id], async () => {
        if (!reservation?.id) return null;

        // A package member's charge is the package's one folio
        if (packageGroup?.id) {
            const packageFolioId = await preparePackageFolio(packageGroup.id)
            setFolioId(packageFolioId)
            return packageFolioId
        }

        // Check if there's a folio for this reservation

        const rates = await RateCalculationService.calculate({
            ids: serviceInfo?.rateIds || [],
            onDate: reservation?.expectedStartDate,
        })

        // Find the correct rate for the reservation start date (take into account also the repeatable rules)
        const targetRate = findRateByDate(rates, reservation.expectedStartDate || new Date())

        // The newest folio that isn't void (the list comes newest first)
        const latestFolio = findLatestNonVoidFolio(await FolioService.getByReservationId(reservation?.id!));
        if (latestFolio) {

            const latestFolioItems = await FolioItemService.getAllFolioItems({
                folioIds: [latestFolio.id as string],
                limit: {
                    offset: 0,
                    limit: 1000,
                    sort: [{field: 'id', direction: 'ASC'}]
                },
            })

            // A signing link that is open or signed confirms the lines as they are: repricing now
            // would make its signature "changed". Read only for drafts - nothing else is repriced.
            const digitalSigningStatus = latestFolio.status === FolioStatus.DRAFT
                ? (await DigitalSigningService.latestForFolio(latestFolio.id!).catch(() => undefined))?.status
                : undefined
            const digitalSigningLive = digitalSigningStatus === 'PENDING'
                || digitalSigningStatus === 'OPENED' || digitalSigningStatus === 'SIGNED'

            // Only DRAFT folio items can be updated. No-show charges keep their line: the charge dialog
            // saves the no-show fee on it.
            if(latestFolio.status === FolioStatus.DRAFT && reservation.status !== ReservationStatus.NO_SHOW && !digitalSigningLive) {
                // Reprice only the reservation's own line (additional lines keep their price) and only
                // with what the rate provides: no price -> keep the stored price, no VAT -> keep the item's VAT
                const primaryItem = findPrimaryFolioItem(latestFolioItems.content, serviceInfo?.id)
                const ratePrice = targetRate?.price
                if (primaryItem) {
                    try {
                        await FolioItemService.updateFolioItem({
                            ...primaryItem,
                            // Carry the serviceId so downstream PMS charges (e.g. Casablanca) can attribute
                            // the line to the right commodity group / VAT source. Backfill it without
                            // clobbering the item's own serviceId.
                            serviceId: primaryItem.serviceId ?? serviceInfo?.id,
                            ...(ratePrice && (ratePrice.amountCents != null || ratePrice.amount != null) ? {
                                price: {
                                    ...ratePrice,
                                    // The backend derives the item total from amountCents
                                    amountCents: ratePrice.amountCents ?? Math.round(ratePrice.amount! * 100),
                                    currency: ratePrice.currency || organization?.currencyCode || "EUR",
                                }
                            } : {}),
                            ...(targetRate?.taxRateId ? {
                                taxRateId: targetRate.taxRateId,
                                taxRateSnap: targetRate.taxRateSnap
                            } : {})
                        })
                    } catch (e) {
                        // Still open the folio — the dialog shows the stored values
                        console.error('Error repricing folio item:', e)
                    }
                    setLatestFolioItemId(primaryItem.id)
                    // Reopening the same folio doesn't reload it, so refresh the dialog's items
                    queryClient.invalidateQueries(['folioItems', latestFolio.id])
                }
            }

            setFolioId(latestFolio.id)
            // The new folio dialog opens the folio it gets back
            return latestFolio.id
        } else {
            // Default folio data to be created when dialog opens
            const newFolioData = {
                name: "Quick Charge",
                status: FolioStatus.DRAFT,
                profileId: reservation?.primaryProfileId || reservation?.profileIds?.[0],
                reservationId: reservation?.id,
                // The organization's currency, like its lines' prices (the backend defaults to it too)
                currency: organization?.currencyCode
            };

            // Immediately create the folio when dialog opens and no existing folio is found
            const createdFolio = await FolioService.create(newFolioData);

            // Create default folio item
            if (createdFolio?.id) {

                const defaultItem: FolioItem = {
                    folioId: createdFolio.id,
                    timeSpanStart: reservation?.expectedStartDate,
                    timeSpanEnd: reservation?.expectedEndDate,
                    description: serviceInfo?.name || "",
                    serviceInventoryCode: serviceInfo?.marketCode || "",
                    // Attribute the primary line to its service so downstream PMS charges (e.g. Casablanca)
                    // resolve the correct commodity group / VAT — without this it falls back to the config
                    // default ("1"). Additional items already carry serviceId via the item autocomplete.
                    serviceId: serviceInfo?.id,
                    price: {
                        ...targetRate?.price,
                        currency: targetRate?.price?.currency || organization?.currencyCode || "EUR",
                    },
                    taxRateId: targetRate?.taxRateId,
                    taxRateSnap: targetRate?.taxRateSnap
                };

                const latestFolioItem = await FolioItemService.createFolioItem(defaultItem);
                setLatestFolioItemId(latestFolioItem.id)
            }

            setFolioId(createdFolio?.id)
            return createdFolio?.id
        }
    }, {
        enabled: false
    })

    // A package member's Charge: the package's one folio (on the group), created on first use or, while a
    // draft, synced with the group - one priced row per package service at its own rate, extras after
    // them, no separate package line
    const preparePackageFolio = async (reservationGroupId: string) => {
        if (!packageService || reservationGroup?.id !== reservationGroupId) return undefined
        try {
            return await buildPackageFolio({
                reservationGroup,
                packageService,
                profileId: reservation?.primaryProfileId || reservation?.profileIds?.[0],
                currencyCode: organization?.currencyCode
            })
        } catch (e) {
            console.error('Error preparing the package folio:', e)
            return undefined
        }
    }

    // Charge: the latest folio is prepared (repriced, or created) - a package member's the package's -,
    // then the new dialog shows it. It opens right away (its skeleton while preparing); without a folio
    // it shows the folio list.
    const openNewCharge = async () => {
        setActionsMenuAnchor(null)
        setFolioDialog({view: 'folio', preparing: true})
        const preparedId = packageGroup?.id
            ? await preparePackageFolio(packageGroup.id)
            : (await prepareLatestFolio.refetch()).data ?? undefined
        setFolioDialog(current => current && {...current, folioId: preparedId, preparing: false})
    }

    // "Charge (deprecated)": the legacy charge dialog, on the same prepared folio
    const openLegacyCharge = () => {
        setActionsMenuAnchor(null)
        prepareLatestFolio.refetch()
        setShowChargeDialog(true)
    }

    // Every reservation is charged - a group's member through its own folios, a package's through the
    // package's -, never blocks
    const chargeOffered = selectedSlotType !== SlotType.BLOCK
    // The guest signed: their tip waits in the new folio dialog, which the legacy charge would skip
    const signedFolioId = digitalSigningSigned ? latestDigitalSigning?.folioId : undefined
    // From the signature on, an icon beside Confirm charge - staff check the signature first - or, once
    // confirmed, beside Charge (the tip is on the finalized folio, whose payment may still be open)
    // shows what the guest signed
    const signedDigitalSigning = isSignedDigitalSigning(latestDigitalSigning?.status) ? latestDigitalSigning : undefined
    // The legacy dialogs come last in the menu, under a divider, until the new folio dialog replaces them -
    // offered as before: the legacy charge only for single reservations and spa packages' members
    const legacyFoliosShown = !reservation?.reservationGroupId && !!reservation?.id
    const legacyChargeShown = (!reservation?.reservationGroupId || isSpaPackageGroup) && chargeOffered && !!reservation?.id

    const closeFolioDialog = () => {
        setFolioDialog(undefined)
        // The signing may have moved on while the dialog was open
        if (reservation?.id) latestDigitalSigningQuery.refetch()
    }

    // sendEmail carries the staff's explicit intent: the split-button main action passes
    // false (silent save), the "& Send Email" menu item passes true. We also persist it to
    // allowNotify state so the multiday update-option dialog path picks up the same choice.
    const handleSaveRes = (sendEmail: boolean = false) => {
        if (selectedSlotType === SlotType.BLOCK) {
            if (requireBlockFields && (blockNameMissing || blockResourcesMissing)) {
                setBlockValidationAttempted(true)
                return
            }
            onSaveBlock?.(blockName)
        } else {
            onSave?.(sendEmail)
        }
    }

    const handleUpdateMultiDayRes = (sendEmail: boolean = false) => {
        setAllowNotify(sendEmail)

        // Assume that we update only the current single reservation
        let multipleUpdateOptions = false

        // In case of multiday reservations -> we need to show dialog for multiple 'update' options
        // This is only the precondition for opening the dialog
        if(linkedReservations && reservation?.id) {
            multipleUpdateOptions = true

            // Another thing is to check the status
            // If the old status is CONFIRMED and the new status is ACTIVE or COMPLETED
            // -> we don't show the dialog but update this single reservation only
            if(originalReservation?.status === ReservationStatus.CONFIRMED &&
                (
                    reservation.status === ReservationStatus.ACTIVE ||
                    reservation.status === ReservationStatus.COMPLETED
                )
            ) {
                multipleUpdateOptions = false
                handleSaveRes(sendEmail)
            }

        } else {
            // Otherwise just keep the multipleUpdate as false
            handleSaveRes(sendEmail)
        }

        setReservationUpdateOptionDialogOpen(multipleUpdateOptions)
    }

    const renderBlockNameField = () => {
        const showError = blockValidationAttempted && blockNameMissing
        return (
            <Box
                flex={1}
            >
                <TextField
                    fullWidth
                    size="small"
                    value={blockName}
                    onChange={(e) => {
                        //  updateField('date', date.value as Date)
                        setBlockName(e.target.value)
                    }}
                    disabled={!canEdit}
                    label={t('Block name')}
                    required={requireBlockFields}
                    error={showError}
                    helperText={showError ? t('Block name is required') : undefined}
                />
            </Box>
        )
    }

    // Setting the start and end date & time for every sector
    // Now we don't have to create new date renders for every sector
    const renderStartDateAndTime = () => {
        return (
            <Box
                flex={1}
            >
                <CDatePicker
                    value={reservation?.expectedStartDate}
                    marked={[
                        {
                            date: reservation?.expectedStartDate
                        }
                    ]}
                    onChange={(date) => {
                        //  updateField('date', date.value as Date)
                        let newEndDate = reservation?.expectedEndDate

                        // If the reservation has the service and service duration, set the end date as:
                        // Start date + service duration
                        if(service?.durationMinutes) {
                            newEndDate = addMinutes(date, service?.durationMinutes)
                        } else {
                            // Default to 1 hour later
                            newEndDate = addHours(date, 1)
                        }

                        setReservation({
                            ...reservation,
                            expectedStartDate: date,
                            expectedEndDate: newEndDate
                        })
                    }}
                    disabled={!canEdit}
                    label={sector?.sectorType === SectorType.ACCOMMODATION ? t('Check in') : t('Start Date & Time')}
                />
            </Box>
        )
    }

    const renderEndDateAndTime = () => {
        return (
            <Box
                flex={1}
            >
                <CDatePicker
                    value={reservation?.expectedEndDate}
                    marked={[
                        {
                            date: reservation?.expectedEndDate
                        }
                    ]}
                    onChange={(date) => {
                        //  updateField('date', date.value as Date)
                        setReservation({
                            ...reservation,
                            expectedEndDate: date
                        })
                    }}
                    disabled={!canEdit}
                    label={sector?.sectorType === SectorType.ACCOMMODATION ? t('Check out') : t('End Date & Time')}
                />
            </Box>
        )
    }

    const renderResourceWarnings = () => {
        // Number of assigned resources to the reservations must be greater than or equal than number of required resources in given sector
        if (!hasRequiredResources(service, reservationResources, restaurantSectorId)) {
            return (
                <Grid item xs={12}>
                    <Alert
                        severity="warning"
                        sx={{
                            padding: "0px 12px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            fontSize: "0.9rem"
                        }}
                    >
                        {t('Resource requirements are not met for this service')}
                    </Alert>
                </Grid>
            )
        }

        if (!resourceWarnings.notLinkedResources.length) {
            return null
        }

        return (
            <Grid item xs={12}>
                <Alert severity={'warning'}>
                    {t('The following resources are not linked to the service', {
                        service: serviceInfo?.name,
                        resources: resourceWarnings.notLinkedResourceNames
                    })}
                </Alert>
            </Grid>
        )
    }

    const renderGuests = () => {
        if (!ageCategories?.length) {
            return null
        }

        const aliasedAgeCategories = ageCategories.filter(ageCategory => ageCategory.alias?.trim())
        const displayGuestCounts = reservation?.displayGuestCounts ?? reservation?.guestCounts ?? []
        const reservationAgeCategoryIds = new Set(
            displayGuestCounts
                .map(guestCount => guestCount.ageCategoryId)
                .filter((id): id is string => Boolean(id))
        )
        const individualAgeCategories = ageCategories.filter(ageCategory => (
            ageCategory.id
            && (ageCategory.alias?.trim() || reservationAgeCategoryIds.has(ageCategory.id))
        ))
        const defaultAgeCategories = resolveDefaultAgeCategories(ageCategories)
        const defaultAgeCategoryIds = new Set(
            defaultAgeCategories.map(ageCategory => ageCategory.id).filter(Boolean)
        )
        const defaultInputs = DEFAULT_AGE_CATEGORY_TYPES.flatMap(type => {
            const ageCategory = defaultAgeCategories.find(category => category.type === type)
            if (!ageCategory?.id) return []

            const label = {
                [AgeCategoryType.ADULT]: t('Adult'),
                [AgeCategoryType.TEENAGER]: t('Teenager'),
                [AgeCategoryType.CHILD]: t('Child'),
                [AgeCategoryType.INFANT]: t('Infant')
            }[type]

            return [{
                key: type,
                label,
                ageCategoryIds: [ageCategory.id],
                targetAgeCategoryId: ageCategory.id
            }]
        })
        const reservationSpecificInputs = ageCategories
            .filter(ageCategory => (
                ageCategory.id
                && reservationAgeCategoryIds.has(ageCategory.id)
                && !defaultAgeCategoryIds.has(ageCategory.id)
            ))
            .flatMap(ageCategory => {
                if (!ageCategory.id) return []
                const name = tFallback(
                    ageCategory.name!,
                    ageCategory.name ?? "Age Category"
                )
                const alias = ageCategory.alias?.trim()

                return [{
                    key: ageCategory.id,
                    label: alias ? `${name} - ${alias}` : name,
                    ageCategoryIds: [ageCategory.id],
                    targetAgeCategoryId: ageCategory.id
                }]
            })
        const guestInputs = aliasedAgeCategories.length
            ? [...individualAgeCategories]
                .sort((a, b) => {
                    if (a.maxAge == null && b.maxAge == null) return 0
                    if (a.maxAge == null) return -1
                    if (b.maxAge == null) return 1
                    return b.maxAge - a.maxAge
                })
                .flatMap(ageCategory => {
                    if (!ageCategory.id) return []
                    const name = tFallback(
                        ageCategory.name!,
                        ageCategory.name ?? "Age Category"
                    )
                    const alias = ageCategory.alias?.trim()
                    return [{
                        key: ageCategory.id,
                        label: alias ? `${name} - ${alias}` : name,
                        ageCategoryIds: [ageCategory.id],
                        targetAgeCategoryId: ageCategory.id
                    }]
                })
            : [...defaultInputs, ...reservationSpecificInputs]

        const itemCount = guestInputs.length

        // Determine grid size based on number of items
        const getGridSize = () => {
            if (itemCount === 1) {
                // 1 item takes full width
                return { xs: 12, sm: 12, md: 12 }
            } else if (itemCount === 2 || itemCount === 4) {
                // 2 columns; four items form a 2x2 grid
                return { xs: 12, sm: 6, md: 6 }
            } else {
                // Max 3 per row
                return { xs: 12, sm: 6, md: 4 }
            }
        }

        const gridSize = getGridSize()

        return (
            <Grid item container xs={12} rowSpacing={3} columnSpacing={2}>
                {guestInputs.map(input => {
                    const inputAgeCategoryIds = new Set(input.ageCategoryIds)
                    const guestCount = displayGuestCounts
                        .filter(count => (
                            count.ageCategoryId && inputAgeCategoryIds.has(count.ageCategoryId)
                        ))
                        .reduce((total, count) => total + (count.count ?? 0), 0)

                    return (
                        <Grid item {...gridSize} key={input.key}>
                            <CountTextField
                                disabled={readOnly}
                                fullWidth
                                label={input.label}
                                value={guestCount}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        padding: '4px'
                                    }
                                }}
                                onChangeValue={e => {
                                    const newGuestCounts = displayGuestCounts
                                        .filter(count => (
                                            !count.ageCategoryId ||
                                            !inputAgeCategoryIds.has(count.ageCategoryId)
                                        ))
                                        .map(count => ({
                                            ageCategoryId: count.ageCategoryId,
                                            count: count.count
                                        }))
                                    newGuestCounts.push({
                                        ageCategoryId: input.targetAgeCategoryId,
                                        count: e
                                    })

                                    setReservation({
                                        ...reservation,
                                        guestCounts: newGuestCounts,
                                        displayGuestCounts: undefined
                                    })
                                }}
                                size={'small'}
                            />
                        </Grid>
                    )
                })}
            </Grid>
        )
    }

    const renderNotes = () => {
        const hasInternalNotes = !!reservation?.notes?.length

        // Always render through the same structure (Stack > TextField) so React never
        // remounts the input when the first note is added, which would drop focus.
        const notesToRender = hasInternalNotes ? reservation!.notes! : [{ note: '' }]

        let renderIndex = 0
        const notes = notesToRender.map((note, index) => {
            const isGuestNote = note.noteType === 'GUEST'
            return (
                <Stack key={renderIndex++} direction="row" alignItems="flex-start" gap={1}>
                    <TextField
                        value={note.note}
                        onChange={(e) => {
                            if (hasInternalNotes) {
                                const newNotes = [...reservation!.notes!]
                                newNotes[index] = { ...newNotes[index], note: e.target.value }
                                setReservation({ ...reservation, notes: newNotes })
                            } else {
                                setReservation({
                                    ...reservation,
                                    notes: [{ note: e.target.value }]
                                })
                            }
                        }}
                        disabled={!canEdit}
                        multiline
                        rows={3}
                        label={isGuestNote ? t('Guest note') : t('Note')}
                        fullWidth
                        InputProps={{
                            startAdornment: hasInternalNotes ? (
                                <NoteGroupIcon
                                    note={note}
                                    index={noteGroupIndex}
                                    sx={{mr: 1, alignSelf: 'flex-start', mt: '3px'}}
                                />
                            ) : undefined,
                        }}
                    />
                    {!isGuestNote && canEdit && hasInternalNotes && (
                        <IconButton
                            size="small"
                            onClick={() => {
                                const newNotes = [...reservation!.notes!]
                                newNotes.splice(index, 1)
                                setReservation({ ...reservation, notes: newNotes })
                            }}
                        >
                            <CloseIcon fontSize="small"/>
                        </IconButton>
                    )}
                </Stack>
            )
        })

        return (
            <Stack gap={2}>
                {notes}
                {hasInternalNotes && canEdit && (
                    <Button
                        size={'small'}
                        sx={{alignSelf: 'flex-start'}}
                        startIcon={<AddIcon/>}
                        onClick={() => {
                            const newNotes = [...(reservation?.notes || [])]
                            newNotes.push({
                                note: ''
                            })
                            setReservation({
                                ...reservation,
                                notes: newNotes
                            })
                        }}
                    >
                        <Typography
                            variant={'subtitle1'}
                        >
                            {t('Add more notes')}
                        </Typography>
                    </Button>
                )}
            </Stack>
        )
    }

    const renderReservationDetails = () => {
        const createActionLabel = selectedSlotType === SlotType.BLOCK
            ? t('Create block period')
            : selectedSlotType === SlotType.SERIAL
                ? t('Create')
                : t('Create reservation')

        return (
            <Stack sx={{
                flex: 1,
                p: 2
            }}>

                <Stack
                    direction={'row'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    width={'100%'}
                >
                    <Typography variant={'h6'}>
                        {
                            reservation?.id
                                ? t('Reservation details')
                                : selectedSlotType === SlotType.BLOCK
                                    ? t('Create a block')
                                    : t('Create a reservation')
                        }
                    </Typography>

                    <Stack
                        direction={'row'}
                        alignItems={'center'}
                        gap={0.5}
                    >
                        {/* A saved booking only; a new one has nothing to copy yet. */}
                        {reservation?.id && <ReservationCopyButton reservation={reservation}/>}
                        <IconButton
                            onClick={onClose}
                        >
                            <CloseIcon/>
                        </IconButton>
                    </Stack>


                </Stack>

                {isSpaPackageGroup && (
                    <Alert severity={'info'} icon={<DynamicFeedIcon fontSize={'inherit'}/>} sx={{mt: 1}}>
                        {reservation?.reservationFromExtraPackageService
                            ? t('Extra service booked with package {{package}} — added to the package bill', {package: packageService?.name})
                            : t('Booked as part of package {{package}} — charged together with the package', {package: packageService?.name})}
                    </Alert>
                )}


                <Grid
                    container
                    rowSpacing={3}
                    columnSpacing={2}
                    sx={{
                        mt: '8px',
                        ...(restaurantInputSizing && {
                            '& .MuiOutlinedInput-root': {
                                minHeight: RESTAURANT_INPUT_MIN_HEIGHT
                            },
                            '& .MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                                minHeight: RESTAURANT_INPUT_MIN_HEIGHT
                            },
                            '& .MuiInputLabel-root.MuiInputLabel-sizeSmall:not(.MuiInputLabel-shrink)': {
                                transform: 'translate(14px, 13px) scale(1)'
                            },
                            '& input.crqlar-date-picker-input': {
                                minHeight: `${RESTAURANT_INPUT_MIN_HEIGHT}px`
                            },
                            '& .MuiAutocomplete-tag .MuiChip-label': {
                                fontSize: '14px',
                                lineHeight: '20px'
                            }
                        }),
                        // minWidth: 500
                    }}

                >
                    {/*Only when creating show the option to switch between reservation / block*/}
                    {!reservation?.id && slotTypeToggle}

                    {/* Position 1:
                        Case Reservation -> Service
                        Case Block -> Start / End date & time
                    */}

                    {
                        selectedSlotType === SlotType.BLOCK ?
                            <>
                                <Grid item xs={12} md={4}
                                      sx={{
                                          alignSelf: 'center',
                                      }}
                                >
                                    {/*When creating a block we need to set additional field -> block name*/}
                                    {renderBlockNameField()}
                                </Grid>

                                <Grid item xs={12} md={4}
                                      sx={{
                                          alignSelf: 'center',
                                      }}
                                >
                                    {renderStartDateAndTime()}
                                </Grid>

                                <Grid item xs={12} md={4}
                                      sx={{
                                          alignSelf: 'center',
                                      }}
                                >
                                    {renderEndDateAndTime()}
                                </Grid>
                            </>

                            :

                            // Otherwise -> just service

                            <>
                                {position1Content}
                            </>
                    }

                    {/* Availability warning — rendered just above the resource picker */}
                    {selectedSlotType !== SlotType.BLOCK && availabilityWarning && (
                        <Grid item xs={12}>
                            {availabilityWarning}
                        </Grid>
                    )}

                    {/* Position 2: Resources */}
                    {!blockHasPreselectedResource && position2Content}

                    {/* Position 3: Restaurant resource (if any) */}
                    {!blockHasPreselectedResource && restaurantResource}

                    {blockValidationAttempted && blockResourcesMissing && (
                        <Grid item xs={12}>
                            <Alert severity="error">
                                {t('Please select at least one resource')}
                            </Alert>
                        </Grid>
                    )}

                    {/* Position 4: Tables (if any)*/}
                    {
                        selectedSlotType !== SlotType.BLOCK && tableResources
                    }

                    {/* Position 5: Number of guests (if any) */}
                    {
                        selectedSlotType !== SlotType.BLOCK &&
                        renderGuests()
                    }

                    {/* Row 6: Start date and time (end-time field removed) */}

                    {
                        selectedSlotType !== SlotType.BLOCK &&
                        <Grid item xs={12} md={6}
                              sx={{
                                  alignSelf: 'center',
                              }}
                        >
                            {renderStartDateAndTime()}
                        </Grid>
                    }

                    {
                        selectedSlotType !== SlotType.BLOCK &&
                        children
                    }

                    {
                        selectedSlotType !== SlotType.BLOCK &&
                        renderResourceWarnings()
                    }

                    {/* Event field — rendered directly on the primary surface */}
                    {
                        selectedSlotType !== SlotType.BLOCK && restaurantEvent &&
                        <Grid item xs={12}>
                            {restaurantEvent}
                        </Grid>
                    }

                    {/* Notes — rendered directly on the primary surface */}
                    {
                        selectedSlotType !== SlotType.BLOCK &&
                        <Grid item xs={12}>
                            {renderNotes()}
                        </Grid>
                    }

                    {(isSerialCreate || isSerialMember) && (
                        <Grid item xs={12}>
                            <Alert severity={'info'} icon={<EmailIcon fontSize={'inherit'}/>}>
                                {t('Guests do not receive transactional emails for serial reservations. To email the guest, open a single reservation of the series and use ⋮ → Email.')}
                            </Alert>
                        </Grid>
                    )}

                </Grid>

                <Stack
                    sx={{
                        mt: 2,
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2,
                        width: '100%',
                        flexWrap: { xs: 'wrap', sm: 'nowrap' }
                    }}
                    direction={'row'}
                >
                    {/* Left cluster: "..." actions menu + charge button */}
                    <Stack
                        direction={'row'}
                        alignItems={'center'}
                        gap={1}
                        sx={{ width: { xs: '100%', sm: 'auto' } }}
                    >
                        <Tooltip title={t('More actions')}>
                            <IconButton onClick={(e) => setActionsMenuAnchor(e.currentTarget)}>
                                <MoreVertIcon/>
                            </IconButton>
                        </Tooltip>

                        <Menu
                            anchorEl={actionsMenuAnchor}
                            open={Boolean(actionsMenuAnchor)}
                            onClose={() => setActionsMenuAnchor(null)}
                        >
                            {canViewLogs && (
                                <MenuItem onClick={() => { onShowLogs?.(); setActionsMenuAnchor(null) }}>
                                    <ListItemIcon><History fontSize="small"/></ListItemIcon>
                                    <ListItemText>{t('Logs')}</ListItemText>
                                </MenuItem>
                            )}
                            {reservation?.id && (
                                <MenuItem onClick={() => { onOpenCommunication?.(); setActionsMenuAnchor(null) }}>
                                    <ListItemIcon><EmailIcon fontSize="small"/></ListItemIcon>
                                    <ListItemText>{t('Email')}</ListItemText>
                                </MenuItem>
                            )}
                            {/* A series is created without the create menu (it would only cover the draft),
                                so the no-show link is sent per sitting from here */}
                            {isSerialMember && onSaveAndSendNoShowLink && (
                                <MenuItem
                                    disabled={readOnly}
                                    onClick={() => { onSaveAndSendNoShowLink(); setActionsMenuAnchor(null) }}
                                >
                                    <ListItemIcon><LinkIcon fontSize="small"/></ListItemIcon>
                                    <ListItemText>{t('Send no-show link')}</ListItemText>
                                </MenuItem>
                            )}
                            {reservation?.id && onOpenFormSelector && (
                                <MenuItem onClick={() => { onOpenFormSelector?.(); setActionsMenuAnchor(null) }}>
                                    <ListItemIcon><AssignmentIcon fontSize="small"/></ListItemIcon>
                                    <ListItemText>{t('Form')}</ListItemText>
                                </MenuItem>
                            )}
                            {reservation?.id && (
                                <MenuItem onClick={() => { setShowSurveyDialog(true); setActionsMenuAnchor(null) }}>
                                    <ListItemIcon><PollIcon fontSize="small"/></ListItemIcon>
                                    <ListItemText>{t('Survey')}</ListItemText>
                                </MenuItem>
                            )}
                            {reservation?.id && (
                                <MenuItem onClick={() => {
                                    setPrintTarget('printout')
                                    setActionsMenuAnchor(null)
                                }}>
                                    <ListItemIcon><PrintIcon fontSize="small"/></ListItemIcon>
                                    <ListItemText>{t('Print (new)')}</ListItemText>
                                </MenuItem>
                            )}
                            {/* The reservation's folios in the new folio dialog - a package member's with the package's */}
                            {reservation?.id && (
                                <MenuItem onClick={() => {
                                    setActionsMenuAnchor(null)
                                    setFolioDialog({view: 'list'})
                                }}>
                                    <ListItemIcon><EuroIcon fontSize="small"/></ListItemIcon>
                                    <ListItemText>{t('Folios')}</ListItemText>
                                </MenuItem>
                            )}
                            {reservation?.id && (
                                <MenuItem onClick={() => {
                                    setPrintTarget('legacy')
                                    setActionsMenuAnchor(null)
                                }}>
                                    <ListItemIcon><PrintIcon fontSize="small"/></ListItemIcon>
                                    <ListItemText>{t('Print')}</ListItemText>
                                </MenuItem>
                            )}
                            {/* The Menu takes no Fragment: the divider and each legacy entry are children of their own */}
                            {(legacyFoliosShown || legacyChargeShown) && <Divider/>}
                            {legacyFoliosShown && (
                                <MenuItem onClick={() => { onShowFolios?.(); setActionsMenuAnchor(null) }}>
                                    <ListItemIcon><EuroIcon fontSize="small"/></ListItemIcon>
                                    <ListItemText>{t('Folios (deprecated)')}</ListItemText>
                                </MenuItem>
                            )}
                            {legacyChargeShown && (
                                <MenuItem onClick={openLegacyCharge} disabled={readOnly}>
                                    <ListItemIcon><PaymentIcon fontSize="small"/></ListItemIcon>
                                    <ListItemText>{t('Charge (deprecated)')}</ListItemText>
                                </MenuItem>
                            )}
                        </Menu>

                        {!!signedDigitalSigning && (
                            <DigitalSigningSignatureButton signing={signedDigitalSigning} onClick={() => setShowDigitalSigning(true)}/>
                        )}
                        {chargeOffered && (signedFolioId ? (
                            // The guest signed: the new dialog opens on the signed folio, where confirming posts the tip
                            <Button
                                variant={'contained'}
                                color={'success'}
                                startIcon={<DrawOutlinedIcon/>}
                                onClick={() => setFolioDialog({view: 'folio', folioId: signedFolioId})}
                                disabled={readOnly}
                            >
                                {t('Confirm charge')}
                            </Button>
                        ) : (
                            // The new folio dialog opens at once, with its skeleton while the latest folio is prepared
                            <Button
                                variant={'outlined'}
                                onClick={openNewCharge}
                                disabled={!reservation?.id || readOnly || groupPending}
                            >
                                {reservation?.status === ReservationStatus.NO_SHOW
                                    ? t('Charge no show')
                                    : packageGroup ? t('Charge package') : t('Charge')}
                            </Button>
                        ))}
                    </Stack>

                    {/* Right cluster: notify checkbox + status dropdown + save/create */}
                    <Stack
                        direction={'row'}
                        alignItems={'center'}
                        gap={2}
                        sx={{ width: { xs: '100%', sm: 'auto' }, justifyContent: 'center', flexWrap: { xs: 'wrap', sm: 'nowrap' } }}
                    >
                        {/* Status dropdown */}
                        {selectedSlotType !== SlotType.BLOCK && reservation && (
                            <ReservationStatusSelect
                                value={reservation.status}
                                isExistingReservation={!!reservation.id}
                                disabled={readOnly}
                                onChange={status => setReservation({
                                    ...reservation,
                                    status
                                })}
                                sx={{minWidth: 130}}
                            />
                        )}

                        {!readOnly && (reservation?.id ? (
                            selectedSlotType === SlotType.BLOCK || reservation?.status === ReservationStatus.ACTIVE || isGroupMember ? (
                                // BLOCK, and ACTIVE reservations, have no "send email" template to fire,
                                // and group members are never emailed, so render a plain Save button
                                // without the split dropdown.
                                <LoadingButton
                                    color={'secondary'}
                                    variant={'contained'}
                                    onClick={() => handleUpdateMultiDayRes(false)}
                                    loading={loading ?? false}
                                >
                                    {t('Save')}
                                </LoadingButton>
                            ) : (
                                <>
                                    {/* Modification: split "Save ▾" — main action saves silently,
                                        the menu item saves and sends the corresponding template. */}
                                    <ButtonGroup ref={saveButtonGroupRef} variant="contained" color="secondary">
                                        <LoadingButton
                                            color={'secondary'}
                                            variant={'contained'}
                                            onClick={() => handleUpdateMultiDayRes(false)}
                                            loading={loading ?? false}
                                        >
                                            {t('Save')}
                                        </LoadingButton>
                                        <Button
                                            color={'secondary'}
                                            variant={'contained'}
                                            size="small"
                                            sx={{ px: 0.5, minWidth: 'auto' }}
                                            onClick={(e) => setSaveMenuAnchor(e.currentTarget)}
                                        >
                                            <ArrowDropDownIcon/>
                                        </Button>
                                    </ButtonGroup>
                                    <Menu
                                        anchorEl={saveButtonGroupRef.current}
                                        open={Boolean(saveMenuAnchor)}
                                        onClose={() => setSaveMenuAnchor(null)}
                                    >
                                        <MenuItem onClick={() => {
                                            handleUpdateMultiDayRes(true)
                                            setSaveMenuAnchor(null)
                                        }}>
                                            {t('Save & send email')}
                                        </MenuItem>
                                    </Menu>
                                </>
                            )
                        ) : (
                            <>
                                {/* Creation: split "Create ▾" action — main action saves silently,
                                    the menu offers "Create & Send Email" and the no-show link. */}
                                <ButtonGroup
                                    ref={createButtonGroupRef}
                                    variant="contained"
                                    color="secondary"
                                    sx={{minWidth: 0, maxWidth: '100%'}}
                                >
                                    <LoadingButton
                                        color={'secondary'}
                                        variant={'contained'}
                                        onClick={() => handleUpdateMultiDayRes(false)}
                                        loading={loading ?? false}
                                        sx={{minWidth: 0, overflow: 'hidden'}}
                                    >
                                        <Box
                                            component="span"
                                            sx={{
                                                minWidth: 0,
                                                maxWidth: '100%',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            {createActionLabel}
                                        </Box>
                                    </LoadingButton>
                                    {selectedSlotType !== SlotType.BLOCK && !isSerialCreate && (
                                        <Button
                                            color={'secondary'}
                                            variant={'contained'}
                                            size="small"
                                            sx={{px: 0.5, minWidth: 'auto', flexShrink: 0}}
                                            onClick={(e) => setCreateMenuAnchor(e.currentTarget)}
                                        >
                                            <ArrowDropDownIcon/>
                                        </Button>
                                    )}
                                </ButtonGroup>
                                <Menu
                                    anchorEl={createButtonGroupRef.current}
                                    open={Boolean(createMenuAnchor)}
                                    onClose={() => setCreateMenuAnchor(null)}
                                >
                                    <MenuItem onClick={() => {
                                        handleUpdateMultiDayRes(true)
                                        setCreateMenuAnchor(null)
                                    }}>
                                        {t('Create reservation & send e-mail')}
                                    </MenuItem>
                                    {onSaveAndSendNoShowLink && (
                                        <MenuItem onClick={() => {
                                            onSaveAndSendNoShowLink?.()
                                            setCreateMenuAnchor(null)
                                        }}>
                                            {t('Create & send no-show link')}
                                        </MenuItem>
                                    )}
                                </Menu>
                            </>
                        ))}
                    </Stack>
                </Stack>
            </Stack>
        )
    }


    return (
        <>
            {renderReservationDetails()}

            <SimpleChargeDialog
                open={showChargeDialog}
                onClose={() => setShowChargeDialog(false)}
                onSuccess={(folio) => {
                    // setShowChargeDialog(false)
                    // Optionally refresh data or show a success message
                }}
                reservation={reservation}
                reservationGroup={packageGroup}
                service={packageGroup ? packageService : serviceInfo}
                folioId={folioId}
            />

            {folioDialog && (
                <FolioDialog
                    open
                    onClose={closeFolioDialog}
                    reservation={reservation}
                    service={serviceInfo}
                    packageGroup={packageGroup}
                    folioId={folioDialog.folioId}
                    preparing={folioDialog.preparing}
                    initialView={folioDialog.view}
                />
            )}

            {showDigitalSigning && !!signedDigitalSigning?.id && (
                <DigitalSigningDetailsDialog
                    id={signedDigitalSigning.id}
                    open
                    onClose={() => setShowDigitalSigning(false)}
                />
            )}

            {showSurveyDialog && !!reservation?.id && (
                <SurveyInviteDialog
                    open
                    onClose={() => setShowSurveyDialog(false)}
                    reservation={reservation}
                />
            )}

            <ReservationUpdateOptionDialog
                open={reservationUpdateOptionDialogOpen}
                onClose={() => setReservationUpdateOptionDialogOpen(false)}
                onConfirm={(updateOption, changes, eatPeriod) => {
                    handleUpdateRes(updateOption, changes, eatPeriod)
                }}
                reservation={reservation}
                originalReservation={originalReservation}
                restaurantResources={resources}
            />

        </>
    )

}
export default ReservationDetailsWrapper;
